import React from 'react';
import { images } from '../../constants';

import './AboutUs.css';

const AboutUs = () => (
  <div className='app__aboutus flex__center section__padding' id="about" style={{height: '100vh'}}>
    <div className='app__aboutus-content flex__center'>

      <div className='app__aboutus-content_knife flex__center'>
        <div className="app__aboutus-content_knife-line"></div>
      </div>

      <div className='app__aboutus-content_history'>
        <h1 className='headtext__cormorant'>About</h1>
          <p className='p__opensans' style={{ margin: '2rem 0', fontSize: '1.35rem'}}>
          Engineer | Reader | Marathon Runner | Guitarist | Traveler | Problem Solver
          </p>
        <p className='p__opensans' style={{margin: '1rem 0', width: '80%', fontSize: '1rem'}}>
          I'm a software engineer with 5+ years of experience building automation and tooling for the automotive industry, from embedded diagnostics to AI-assisted test workflows. I started out writing UDS test scripts and OTX automation for clients like Panasonic, Eaton, and Honda, then moved into leading validation engineering for engine ECUs at Cummins and, more recently, in-vehicle software at Ford Motor Company.
          I like solving problems where code meets hardware - rewriting validation tools to support new protocols, automating manual processes that used to take hours down to minutes, and building AI agents that help engineers work smarter. A few things I'm proud of: cutting a 4,800+ test case update process from 30 hours to 10 minutes, and building an AI tool that shaves 15-20% off test execution time by suggesting more efficient test sequences.
          Outside of shipping code, I'm always looking for the next system worth understanding - reading, experimenting, and picking up whatever skills the problem in front of me demands.
        </p>
      </div>

    </div>
  </div>
);

export default AboutUs;
